// @flow
import React, {PureComponent} from 'react';
import {StyleSheet, View} from 'react-native';
import {withNavigation} from '@react-navigation/compat';
import {
  ConfirmationModal,
  FullButton,
  GenericPostRequestModal,
  WarningFrame,
} from '../../../../components/common';
import I18n from '../../../../lib/i18n';
import theme from '../../../../theme-config';
import config from '../../../../config';
import * as Navigation from '../../../../lib/navigation.js';

import type {LoadingStatusStateType} from '../../../../modules/LoadingStatus';

class SuspensionStatus extends PureComponent<Props> {
  styles = getStyles();

  unsuspendButton = () => (
    <FullButton textStyle={this.styles.buttonText} style={this.styles.button} />
  );

  goToHelpCenter = () => Navigation.navigate('helpCenter');

  unsuspendOrGetMoreInfo = () => {
    if (!this.props.isSuspendedByCustomer) {
      return (
        <FullButton
          text={I18n.t('Dashboard.SuspensionStatus.suspendedByAgentButton')}
          textStyle={this.styles.buttonText}
          style={this.styles.button}
          onPress={this.goToHelpCenter}
        />
      );
    }

    if (config.canUnsuspend) {
      return (
        <ConfirmationModal
          openModalText={I18n.t('Dashboard.SuspensionStatus.unsuspendButton')}
          confirmContent={I18n.t(
            'Dashboard.SuspensionStatus.confirmModalContent',
          )}
          ButtonComponent={this.unsuspendButton()}
          onConfirm={this.props.unsuspendLine}
        />
      );
    }

    return null;
  };

  render() {
    if (!this.props.isPendingSuspended && !this.props.isSuspended) return null;
    return (
      <View>
        <WarningFrame
          text={
            this.props.isSuspendedByCustomer
              ? this.props.isSuspended
                ? I18n.t('Dashboard.SuspensionStatus.suspendedTitle')
                : I18n.t('Dashboard.SuspensionStatus.pendingSuspendedTitle')
              : I18n.t('Dashboard.SuspensionStatus.suspendedByAgentTitle')
          }
          Button={
            !this.props.isPendingSuspended && this.unsuspendOrGetMoreInfo()
          }
          style={this.props.style}
        />
        <GenericPostRequestModal loadingSelector={this.props.loadingSelector} />
      </View>
    );
  }
}

type Props = {style?: any} & StateProps & DispatchProps;

export type StateProps = {
  isPendingSuspended: boolean,
  isSuspended: boolean,
  isSuspendedByCustomer: boolean,
  loadingSelector: $Keys<LoadingStatusStateType>,
};

export type DispatchProps = {
  unsuspendLine: Function,
};

const getStyles = () =>
  StyleSheet.create({
    buttonText: {
      color: theme.errorColor,
      fontSize: 16,
    },
    button: {
      backgroundColor: 'white',
      marginTop: 12,
      paddingRight: 20,
      paddingLeft: 20,
    },
  });

export default withNavigation(SuspensionStatus);
